import React from 'react';
import ReactDOM from 'react-dom/client';
import RoundingApp from './RoundingApp';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RoundingApp />
  </React.StrictMode>
);
